import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base/use-case";
import { MasterlocationRepository } from "../../repositories/master-location.repository";
import { LocationType } from "../../domain/models/location-type";

@Injectable({ providedIn: 'root' })
export class GetLocationTypeUseCase implements UseCase<null, LocationType[]> {

  constructor(private readonly masterlocationRepository: MasterlocationRepository) {
  }

  execute(): Observable<LocationType[]> {
    return this.masterlocationRepository.getLocationTypes();
  }

}